import { formatUIDateTime } from 'utils/helpers'

export const toTableRowItems = items =>
  items.map(item => ({
    id: item.id,
    shopCode: item.shopCode ?? '',
    supplierCode: item.supplierCode ?? '',
    supplierName: item.supplierName ?? '',
    parentSociety: item.parentSociety ?? '',
    truckNumber: item.truckNumber ?? '',
    driverName: item.driverName ?? '',
    lastUpdateBy: item.lastUpdateBy ?? '',
    noticeNumber: item.noticeNumber ?? '',
    noticeSeries: item.noticeSeries ?? '',
    registrationDate: item.registrationDate ? formatUIDateTime(item.registrationDate) : '',
    expeditionDate: item.expeditionDate ? formatUIDateTime(item.expeditionDate) : '',
    truckStatus: item.truckStatus ?? '',
    truckStatusValue: item.truckStatusValue ?? '',
  }))
